import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../queryKeys";

import { readUsageStatistics } from "@/services/api/usage";
import { UsageStatisticsRequest } from "@/types/usage";

// 사용 현황 통계 조회
export const useUsageStatistics = ({
  start_date,
  end_date,
}: UsageStatisticsRequest) => {
  return useQuery({
    queryKey: QUERY_KEYS.USAGE.STATISTICS(start_date, end_date),
    queryFn: () => readUsageStatistics({ start_date, end_date }),
  });
};
